import React, { memo } from "react";
import { Chip } from "@mui/material";

function ReleaseStatusChip({ status = false }) {
  let chipParams = { label: "Not Released" };
  if (status) {
    chipParams = {
      label: "Released",
      color: "success",
    };
  }
  return <Chip size="small" {...chipParams} />;
}

export default memo(ReleaseStatusChip);
